import { useState, useCallback, useEffect } from 'react';

import { Grid, FormControl, RadioGroup, FormControlLabel, Radio, Typography, Button, Checkbox } from '@mui/material';
import { MultilineField, TextField, SelectField, Autocomplete, DateTimePicker } from '../style-guide';
import DialogWithGoBackWrapper from '../style-guide/Dialog/DialogWithGoBack';

import { sendRequest, REQUEST_ACTIONS, setOrderData, updateOrder, setOrderForSave } from 'utils/Communicator';
import { addOrderFilter, addSearchFilter } from 'Utils';

import { useDispatch, useSelector } from 'react-redux';
import { addShipper, updateShipper, onPickupAddressChange } from 'reducers/shippersSlicer';
import { addCustomer, updateCustomer } from 'reducers/customersSlicer';
import { onUsersLocationChange } from 'reducers/UsersSlicer';
import { addConsignee, updateConsignee } from 'reducers/consigneesSlicer';
import { addVendor, updateVendor, add, updateServiceProviders } from 'reducers/VendorSlicer';
import { addTruckingCompany, updateTruckingCompany } from 'reducers/TruckingCompanySlicer';
import { snackbarToggle } from 'reducers/snackbarSlicer';
import { onFunctionChange } from 'reducers/order-reducers/predefinedDataSlicer';
import { getOrders } from 'reducers/order-reducers/ordersSlicer';


const AddServiceProvider = props => {
    const {
        userLocalNumber,
        userAbroadNumber,
        consigneeId,
        customerId,
        shipperId,
        countryOfOriginId, originState,
        shippingModeId,
        subModeId,
        userLocalId,
        userTracer,
        userCustoms, urgentShipment, fileNumber,
        userAbroadId,
        dueDate,
        lastUpdateDate,
        ilReminderDate,
        reminderDate,
        selectedLocationIndex,
        selectedTabIndexName,
        search,
        startReminderDate,
        endReminderDate,
        startIlReminderDate,
        endIlReminderDate,
        stageSearch,
        stageStateSearch,
        reminderDateAdv, ilReminderDateAdv, sortFilter, etaDate, etdDate, fileUploadStatus } = useSelector(state => state.orderTableFilter);
    const { page, size, chatCount, userSpecificOrdersCount, unConfirmedOrdersCount } = useSelector(state => state.orders);
    const { countryOfOriginData, serviceProviderType } = useSelector(state => state.predefinedData);
    const dispatch = useDispatch();
    const { usersLocation } = useSelector(state => state.users);
    const { pickupAddress } = useSelector(state => state.shippers);
    const [openOrderModal, setOpenOrderModal] = useState(false);
    const [lockerId, setLockerId] = useState(null);
    const onHandleCancelModal = () => setOpenOrderModal(false);

    const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);

    const [userILImporter, setUserILImporter] = useState([]);
    const [userILTracer, setUserILTracer] = useState([]);
    const [userILCustoms, setUserILCustoms] = useState([]);
    const [userILSales, setUserILSales] = useState([]);
    const [consigneeList, setConsigneeList] = useState([]);
    const crm_states = [{ id: 2, name: "Lead" }, { id: 3, name: "Account" }]
    const {
        userILNames
    } = useSelector(state => state.predefinedData);


    const [emailNotificationShipperAll, setEmailNotificationShipperAll1] = useState(false);
    const [emailNotificationShipper1, setEmailNotificationShipper1] = useState(false);
    const [emailNotificationShipper2, setEmailNotificationShipper2] = useState(false);
    const [emailNotificationShipper3, setEmailNotificationShipper3] = useState(false);
    const [emailNotificationShipper4, setEmailNotificationShipper4] = useState(false);
    const [emailNotificationShipper5, setEmailNotificationShipper5] = useState(false);
    const [emailNotificationShipper6, setEmailNotificationShipper6] = useState(false);
    const [emailNotificationShipper7, setEmailNotificationShipper7] = useState(false);
    const [emailNotificationShipper8, setEmailNotificationShipper8] = useState(false);
    const [emailNotificationTruckingAll, setEmailNotificationTruckingAll1] = useState(false);
    const [emailNotificationTrucking1, setEmailNotificationTrucking1] = useState(false);
    const [emailNotificationTrucking2, setEmailNotificationTrucking2] = useState(false);
    const [emailNotificationDEPAll, setEmailNotificationDEPAll1] = useState(false);
    const [emailNotificationDEP1, setEmailNotificationDEP1] = useState(false);
    const [emailNotificationDEP2, setEmailNotificationDEP2] = useState(false);
    const [emailNotificationDEP3, setEmailNotificationDEP3] = useState(false);
    const [emailNotificationDEP4, setEmailNotificationDEP4] = useState(false);
    const [emailNotificationCustoms1, setEmailNotificationCustoms1] = useState(false);
    const [emailNotificationDelivered1, setEmailNotificationDelivered1] = useState(false);

    const setEmailNotificationShipperAll = (data) => {
        setEmailNotificationShipperAll1(data);
        setEmailNotificationShipper1(data);
        setEmailNotificationShipper2(data);
        setEmailNotificationShipper3(data);
        setEmailNotificationShipper4(data);
        setEmailNotificationShipper5(data);
        setEmailNotificationShipper6(data);
        setEmailNotificationShipper7(data);
        setEmailNotificationShipper8(data);
    }
    const setEmailNotificationTruckingAll = (data) => {
        setEmailNotificationTruckingAll1(data);
        setEmailNotificationTrucking1(data);
        setEmailNotificationTrucking2(data);
    }
    const setEmailNotificationDEPAll = (data) => {
        setEmailNotificationDEPAll1(data);
        setEmailNotificationDEP1(data);
        setEmailNotificationDEP2(data);
        setEmailNotificationDEP3(data);
        setEmailNotificationDEP4(data);
    }
    useEffect(() => {
        if (emailNotificationShipper1 && emailNotificationShipper2 && emailNotificationShipper3 && emailNotificationShipper4 && emailNotificationShipper5 && emailNotificationShipper6 && emailNotificationShipper7 && emailNotificationShipper8)
            setEmailNotificationShipperAll1(true);
        else
            setEmailNotificationShipperAll1(false);
    }, [emailNotificationShipper1,
        emailNotificationShipper2,
        emailNotificationShipper3,
        emailNotificationShipper4,
        emailNotificationShipper5,
        emailNotificationShipper6,
        emailNotificationShipper7,
        emailNotificationShipper8]);
    useEffect(() => {
        if (emailNotificationTrucking1 && emailNotificationTrucking2)
            setEmailNotificationTruckingAll1(true);
        else
            setEmailNotificationTruckingAll1(false);
    }, [emailNotificationTrucking1,
        emailNotificationTrucking2]);
    useEffect(() => {
        if (setEmailNotificationDEP1 && setEmailNotificationDEP2 && setEmailNotificationDEP3 && setEmailNotificationDEP4)
            setEmailNotificationDEPAll1(true);
        else
            setEmailNotificationDEPAll1(false);
    }, [setEmailNotificationDEP1,
        setEmailNotificationDEP2,
        setEmailNotificationDEP3,
        setEmailNotificationDEP4]);

    useEffect(() => {
        var importers = [];
        var tracers = [];
        var customs = [];
        var sales = [];

        importers = userILNames.filter(name => name.department == 1 || name.department == null);
        tracers = userILNames.filter(name => name.department == 2);
        customs = userILNames.filter(name => name.department == 3);
        sales = userILNames.filter(name => name.department == 4);

        setUserILImporter(importers);
        setUserILTracer(tracers);
        setUserILCustoms(customs);
        setUserILSales(sales);
    }, []);


    const [value, setValue] = useState(
        props.data
            ? props.data
            : {
                id: null,
                serviceProviderTypeId: props.type ? props.type : null,
                serviceProviderTypeId1: props.type ? props.type : null,
                serviceProviderLocationId: null,
                city: null,
                customer: 'IS_CUSTOMER',
                countryId: null,
                companyName: null,
                companyShortName: null,
                localName: null,
                scac: null,
                shippingLineNumber: null,
                zipCode: null,
                iuser: null,
                ouser: null,
                cuser: null,
                suser: null,
                co:null,
                useCustoms: false,
                useDelivery: false,
                state: null,
                salesman: null,
                phone: null,
                fax: null,
                email: null,
                position: null,
                mobile: null,
                name: null,
                businessPhone: null,
                faxContent: null,
                email2: null,
                position2: null,
                mobile2: null,
                name2: null,
                businessPhone2: null,
                faxContent2: null,
                email3: null,
                position3: null,
                mobile3: null,
                name3: null,
                businessPhone3: null,
                faxContent3: null,
                email4: null,
                position4: null,
                mobile4: null,
                name4: null,
                businessPhone4: null,
                faxContent4: null,
                email5: null,
                position5: null,
                mobile5: null,
                name5: null,
                businessPhone5: null,
                faxContent5: null,
                uatnumber: null,
                address2: null,
                address1: null,
                functionsId: null,
                sameAsShipper: 'sameAsShipper',
                pickupAddress: null,
                active: true,
                notificationMail:"",
                status: "",
                code: "",
                crmStatus: null,
                dob: null,
                reminderDate: null,
                reminderText: null,
                commercial: null,
            },
    );
    useEffect(() => {
        if (value?.status) {
            var notifications = value.status?.split(",");
            if (notifications.length != 16) {
                setEmailNotificationShipperAll(true);
                setEmailNotificationTruckingAll(true);
                setEmailNotificationDEPAll(true);
                setEmailNotificationCustoms1(true);
                setEmailNotificationDelivered1(true);
            } else {
                setEmailNotificationShipper1(notifications[0] === "true" ? true : false);
                setEmailNotificationShipper2(notifications[1] === "true" ? true : false);
                setEmailNotificationShipper3(notifications[2] === "true" ? true : false);
                setEmailNotificationShipper4(notifications[3] === "true" ? true : false);
                setEmailNotificationShipper5(notifications[4] === "true" ? true : false);
                setEmailNotificationShipper6(notifications[5] === "true" ? true : false);
                setEmailNotificationShipper7(notifications[6] === "true" ? true : false);
                setEmailNotificationShipper8(notifications[7] === "true" ? true : false);
                setEmailNotificationTrucking1(notifications[8] === "true" ? true : false);
                setEmailNotificationTrucking2(notifications[9] === "true" ? true : false);
                setEmailNotificationDEP1(notifications[10] === "true" ? true : false);
                setEmailNotificationDEP2(notifications[11] === "true" ? true : false);
                setEmailNotificationDEP3(notifications[12] === "true" ? true : false);
                setEmailNotificationDEP4(notifications[13] === "true" ? true : false);
                setEmailNotificationCustoms1(notifications[14] === "true" ? true : false);
                setEmailNotificationDelivered1(notifications[15] === "true" ? true : false);
            }
        }
    }, [value]);

    useEffect(() => {

        sendRequest(`/api/serviceProvider/2`, REQUEST_ACTIONS.GET, '', {
            successCallback: response => {
                var res = [];
                for (var i = 0; i < response.length; i++) {
                    res.push({ id: response[i].id, name: response[i].companyName })
                }
                setConsigneeList(res);
            },
            failedCallback,
        });
        if (value.id && props.pageName == "manifest") {
            sendRequest('/api/parcel/manifestToken/' + value.id, REQUEST_ACTIONS.GET, '', {
                successCallback: response => {
                    setLockerId(response?.token);
                },
                failedCallback,
            });
        }

        if (serviceProviderType == null || serviceProviderType.length == 0) {
            sendRequest('/api/function', REQUEST_ACTIONS.GET, '', {
                successCallback: response => {
                    dispatch(onFunctionChange(response.filter(functions => functions.name !== 'new pickup Address')));
                },
                failedCallback,
            });
        }

        sendRequest('/api/locations', REQUEST_ACTIONS.GET, '', {
            successCallback: response => dispatch(onUsersLocationChange(response)),
            failedCallback
        });
    }, [dispatch, failedCallback]);

    const readOnly = props.readOnly;
    useEffect(() => {
        setValue(prev => ({ ...prev, pickupAddress: pickupAddress }));
    }, [pickupAddress]);

    const handleChange = event => {
        setValue(prev => ({ ...prev, customer: event.target.value }));
    };
    const handleChanges = event => {
        setValue(prev => ({ ...prev, sameAsShipper: event.target.value }));
        if (value.sameAsShipper === 'sameAsShipper') {
            setValue(prev => ({ ...prev, pickupAddress: null }));
        }
        if (event.target.value === 'differentAddress') {
            setOpenOrderModal(true);
        }
    };

    const create = () => {
        if (!value.serviceProviderLocationId) {
            dispatch(snackbarToggle({ type: 'error', message: "Please select W/H location" }));
            return;
        }
        var status = "" + emailNotificationShipper1 + "," + emailNotificationShipper2 + "," + emailNotificationShipper3 + "," + emailNotificationShipper4 + "," + emailNotificationShipper5 + "," + emailNotificationShipper6 + "," + emailNotificationShipper7 + "," + emailNotificationShipper8;
        status = status + "," + emailNotificationTrucking1 + "," + emailNotificationTrucking2;
        status = status + "," + emailNotificationDEP1 + "," + emailNotificationDEP2 + "," + emailNotificationDEP3 + "," + emailNotificationDEP4;
        status = status + "," + emailNotificationCustoms1;
        status = status + "," + emailNotificationDelivered1;
        value.status = status;
        sendRequest('/api/serviceProvider', REQUEST_ACTIONS.POST, value, {
            successCallback: response => {
                if (response.serviceProviderTypeId === 5) {
                    dispatch(onPickupAddressChange(response));
                } else {
                    if (response.serviceProviderTypeId === 1) {
                        dispatch(addShipper(response));
                        dispatch(onPickupAddressChange(null));
                    } else if (response.serviceProviderTypeId === 2) {
                        dispatch(addConsignee(response));
                        dispatch(onPickupAddressChange(null));
                    } else if (response.serviceProviderTypeId === 4) {
                        dispatch(addVendor(response));
                    } else if (response.serviceProviderTypeId === 13) {
                        dispatch(addCustomer(response));
                    } else {
                        dispatch(addTruckingCompany(response));
                    }
                    dispatch(add(response));
                }
                sendRequest(`/api/order/advOrders?${addOrderFilter(props.loginUser, props.pageName, selectedLocationIndex)}${addSearchFilter(customerId, urgentShipment, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, search, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, props.pageName, sortFilter, fileNumber, etaDate, etdDate, fileUploadStatus)}page=${page}&size=${size}`, REQUEST_ACTIONS.GET, '', {
                    successCallback: response => {
                        setOrderData(dispatch, getOrders, response, props.loginUser, failedCallback);
                        dispatch(
                            snackbarToggle({
                                type: 'success',
                                message: 'CRM created successfully',
                            }),
                        );
                        props.onHandleCancel();
                    },
                    failedCallback,
                });
                //props.onHandleCancel();
            },
            failedCallback,
        });
    };

    const update = () => {
        var status = "" + emailNotificationShipper1 + "," + emailNotificationShipper2 + "," + emailNotificationShipper3 + "," + emailNotificationShipper4 + "," + emailNotificationShipper5 + "," + emailNotificationShipper6 + "," + emailNotificationShipper7 + "," + emailNotificationShipper8;
        status = status + "," + emailNotificationTrucking1 + "," + emailNotificationTrucking2;
        status = status + "," + emailNotificationDEP1 + "," + emailNotificationDEP2 + "," + emailNotificationDEP3 + "," + emailNotificationDEP4;
        status = status + "," + emailNotificationCustoms1;
        status = status + "," + emailNotificationDelivered1;
        value.status = status;
        sendRequest('/api/serviceProvider', REQUEST_ACTIONS.PUT, value, {
            successCallback: response => {
                if (response.serviceProviderTypeId === 5) {
                    dispatch(onPickupAddressChange(response));
                } else {
                    if (response.serviceProviderTypeId === 2) {
                        dispatch(updateConsignee(response));
                    } else if (response.serviceProviderTypeId === 4) {
                        dispatch(updateVendor(response));
                    } else if (response.serviceProviderTypeId === 1) {
                        dispatch(updateShipper(response));
                    } else if (response.serviceProviderTypeId === 13) {
                        dispatch(updateCustomer(response));
                    } else {
                        dispatch(updateTruckingCompany(response));
                    }
                    dispatch(updateServiceProviders(response));
                }
                sendRequest(`/api/order/advOrders?${addOrderFilter(props.loginUser, props.pageName, selectedLocationIndex)}${addSearchFilter(customerId, urgentShipment, userLocalNumber, userAbroadNumber, consigneeId, shipperId, countryOfOriginId, originState, shippingModeId, subModeId, userLocalId, userTracer, userCustoms, userAbroadId, dueDate, search, lastUpdateDate, reminderDate, ilReminderDate, startReminderDate, endReminderDate, startIlReminderDate, endIlReminderDate, stageSearch, stageStateSearch, reminderDateAdv, ilReminderDateAdv, props.pageName, sortFilter, fileNumber, etaDate, etdDate, fileUploadStatus)}page=${page}&size=${size}`, REQUEST_ACTIONS.GET, '', {
                    successCallback: response => {
                        setOrderData(dispatch, getOrders, response, props.loginUser, failedCallback);
                        dispatch(
                            snackbarToggle({
                                type: 'success',
                                message: 'CRM updated successfully',
                            }),
                        );
                        props.onHandleCancel();
                    },
                    failedCallback,
                });
                //props.onHandleCancel();
            },
            failedCallback,
        });
    };

    return (
        <div>
            {!openOrderModal && (
                <Grid container spacing={2}>
                    <Grid item xs={12} pt='0 !important' style={{ display: 'none' }}>
                        <FormControl component='fieldset' disabled={readOnly}>
                            <RadioGroup value={value.customer} onChange={handleChange}>
                                <FormControlLabel
                                    value='IS_CUSTOMER'
                                    control={<Radio size='small' />}
                                    label='Is Customer (Allows more options in customer management)'
                                    disabled={readOnly}
                                />
                                <FormControlLabel
                                    value='SHIPPER_CONSIGNEE_IS_NOT_CUSTOMER'
                                    control={<Radio size='small' />}
                                    label='Shipper / Consignee is Not my customer'
                                    disabled={readOnly}
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                    <Grid container item xs={6} spacing={2}>
                        {lockerId != null ?
                            <TextField
                                lg={null}
                                md={null}
                                sm={null}
                                value={lockerId}
                                label='Locker Id'
                                readOnly={readOnly}
                            /> : null}
                        <TextField
                            required
                            lg={null}
                            md={null}
                            sm={null}
                            value={value.companyName}
                            onChange={event => setValue(prev => ({ ...prev, companyName: event.target.value }))}
                            label='CompanyName'
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            md={null}
                            sm={null}
                            value={value.companyShortName}
                            onChange={event => setValue(prev => ({ ...prev, companyShortName: event.target.value }))}
                            label='Company Short Name'
                            readOnly={readOnly}
                        />
                        {(value.serviceProviderTypeId !== 5 || value.serviceProviderType?.id !== 5) && (
                            <SelectField
                                required
                                lg={null}
                                md={null}
                                sm={null}
                                label='Major Functions'
                                value={value.serviceProviderTypeId || value.serviceProviderType?.id}
                                onChange={event => setValue(prev => ({ ...prev, serviceProviderTypeId: event.target.value }))}
                                options={serviceProviderType}
                                disabled={readOnly}
                            />
                        )}
                        {(value.serviceProviderTypeId1 !== 5 || value.serviceProviderType1?.id !== 5) && (
                            <SelectField
                                lg={null}
                                md={null}
                                sm={null}
                                label='Minor Functions'
                                value={value.serviceProviderTypeId1 || value.serviceProviderType1?.id}
                                onChange={event => setValue(prev => ({ ...prev, serviceProviderTypeId1: event.target.value }))}
                                options={serviceProviderType}
                                disabled={readOnly}
                            />
                        )}
                        {(value.serviceProviderTypeId === 6 || value.serviceProviderTypeId1 === 6 || value.serviceProviderType?.id === 6 || value.serviceProviderType1?.id === 6) && (
                            <TextField
                                lg={null}
                                md={null}
                                sm={null}
                                value={value.shippingLineNumber}
                                onChange={event => setValue(prev => ({ ...prev, shippingLineNumber: event.target.value }))}
                                label='Shipping Line Number'
                                readOnly={readOnly}
                            />
                        )}

                        <TextField
                            lg={null}
                            md={null}
                            sm={null}
                            value={value.address1}
                            onChange={event => setValue(prev => ({ ...prev, address1: event.target.value }))}
                            label='Address1'
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            md={null}
                            sm={null}
                            value={value.localName}
                            onChange={event => setValue(prev => ({ ...prev, localName: event.target.value }))}
                            label='LocalName'
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            md={null}
                            sm={null}
                            value={value.scac}
                            onChange={event => setValue(prev => ({ ...prev, scac: event.target.value }))}
                            label='SCAC'
                            readOnly={readOnly}
                        />

                        {<Autocomplete
                            field='status'
                            label='Status'
                            lg={6}
                            value={Number(value.crmStatus)}
                            onChange={(event, value) => {
                                setValue(prev => ({ ...prev, crmStatus: value }))
                            }}
                            options={crm_states}
                            readOnly={readOnly}
                            disabled={readOnly}
                        />}
                        {/*<SelectField
                            lg={6}
                            label='Status'
                            value={value.crmStatus}
                            onChange={event => setValue(prev => ({ ...prev, crmStatus: event.target.value }))}
                            options={crm_states}
                            disabled={readOnly}
                        />*/}
                        <DateTimePicker
                            lg={6}
                            label='DOB'
                            boldLabel={<Typography fontSize="0.8vw" fontWeight='bold'>DOB</Typography>}
                            value={value.dob}
                            isShowTime={false}
                            format="dd/MM/yyyy"
                            onChange={date => setValue(prev => ({ ...prev, dob: date?.toISOString() }))}
                        />
                        <SelectField
                            required
                            lg={6}
                            label='Country'
                            value={value.countryId}
                            onChange={event => setValue(prev => ({ ...prev, countryId: event.target.value }))}
                            options={countryOfOriginData}
                            disabled={readOnly}
                        />
                        <TextField
                            required
                            lg={6}
                            label='City'
                            value={value.city}
                            onChange={event => setValue(prev => ({ ...prev, city: event.target.value }))}
                            options={countryOfOriginData}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            value={value.zipCode}
                            onChange={event => setValue(prev => ({ ...prev, zipCode: event.target.value }))}
                            label='Zip Code'
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={4}
                            value={value.state}
                            onChange={event => setValue(prev => ({ ...prev, state: event.target.value }))}
                            label='State'
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={4}
                            value={value.salesman}
                            onChange={event => setValue(prev => ({ ...prev, salesman: event.target.value }))}
                            label='Salesman'
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={6}
                            label='Area Code'
                            value={value.code}
                            onChange={event => setValue(prev => ({ ...prev, code: event.target.value }))}
                            readOnly={readOnly}
                        />
                        {<Autocomplete
                            field='co'
                            label='C/O'
                            lg={6}
                            value={Number(value.co)}
                            onChange={(event, value) => {
                                setValue(prev => ({ ...prev, co: value }))
                            }}
                            options={consigneeList}
                            readOnly={readOnly}
                            disabled={readOnly}
                        />}
                        {(value.serviceProviderType?.id === 1 || value.serviceProviderType?.id === 2 || value.serviceProviderTypeId === 1 || value.serviceProviderTypeId === 2 || value.serviceProviderTypeId1 === 1 || value.serviceProviderTypeId1 === 2) && (
                            <FormControl
                                component='fieldset'
                                disabled={readOnly}
                                style={{
                                    paddingTop: 10,
                                    paddingLeft: 20,
                                }}>
                                <Typography color='#1976d2'>Pick up Address</Typography>
                                <RadioGroup value={value.sameAsShipper} onChange={event => handleChanges(event)}>
                                    <FormControlLabel
                                        value='sameAsShipper'
                                        control={<Radio size='small' />}
                                        label='Same as shippers Address'
                                        disabled={readOnly}
                                    />
                                    <FormControlLabel
                                        value='differentAddress'
                                        control={<Radio size='small' />}
                                        label='Different Address'
                                        disabled={readOnly}
                                    />
                                </RadioGroup>
                                <Typography color='#1976d2'>
                                    {' '}
                                    {props.data?.pickupAddress?.companyName || value.pickupAddress?.companyName || null}
                                </Typography>
                            </FormControl>
                        )}
                    </Grid>
                    <Grid container item xs={4} spacing={2} maxHeight='1px'>
                        <SelectField
                            required
                            lg={null}
                            md={null}
                            sm={null}
                            label='Location'
                            value={value.serviceProviderLocationId}
                            onChange={event => setValue(prev => ({ ...prev, serviceProviderLocationId: event.target.value }))}
                            options={usersLocation}
                            disabled={readOnly}
                        />
                        <TextField
                            lg={null}
                            md={null}
                            sm={null}
                            value={value.uatnumber}
                            onChange={event => setValue(prev => ({ ...prev, uatnumber: event.target.value }))}
                            label='VAT Number'
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            md={null}
                            sm={null}
                            value={value.phone}
                            onChange={event => setValue(prev => ({ ...prev, phone: event.target.value }))}
                            label='Phone'
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            md={null}
                            sm={null}
                            value={value.fax}
                            onChange={event => setValue(prev => ({ ...prev, fax: event.target.value }))}
                            label='Fax'
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            md={null}
                            sm={null}
                            value={value.address2}
                            onChange={event => setValue(prev => ({ ...prev, address2: event.target.value }))}
                            label='Address2'
                            readOnly={readOnly}
                        />


                        <Autocomplete
                            field='salesUser'
                            label='Salesman'
                            lg={12}
                            value={Number(value.suser)}
                            onChange={(event, value) => {
                                setValue(prev => ({ ...prev, suser: value }))
                            }}
                            options={userILSales}
                        />
                        <TextField
                            lg={null}
                            md={null}
                            sm={null}
                            value={value.commercial}
                            onChange={event => setValue(prev => ({ ...prev, commercial: event.target.value }))}
                            label='Commercial'
                            readOnly={readOnly}
                        />
                        <Autocomplete
                            field='impUser'
                            label='F/U'
                            lg={12}
                            value={value.iuser}
                            onChange={(event, value) => {
                                setValue(prev => ({ ...prev, iuser: value }))
                            }}
                            options={userILImporter}
                        />
                        <Autocomplete
                            field='opsUser'
                            label='OPS'
                            lg={12}
                            value={value.ouser}
                            onChange={(event, value) => setValue(prev => ({ ...prev, ouser: value }))}
                            options={userILTracer}
                        />
                        <Autocomplete
                            field='customsUser'
                            label='CUSTOMS'
                            lg={12}
                            value={value.cuser}
                            onChange={(event, value) => setValue(prev => ({ ...prev, cuser: value }))}
                            options={userILCustoms}
                        />

                        <FormControlLabel
                            control={
                                <Checkbox checked={value.useCustoms} onChange={event => setValue(prev => ({ ...prev, useCustoms: event.target.checked }))} />
                            }
                            label='No Custom Service'
                        />

                        <FormControlLabel
                            control={
                                <Checkbox checked={value.useDelivery} onChange={event => setValue(prev => ({ ...prev, useDelivery: event.target.checked }))} />
                            }
                            label='Without delivered service'
                        />

                    </Grid>
                    <Grid container item spacing={1} justifyContent="flex-end" style={{marginTop: "10px"}}>
                        <MultilineField
                            xs={12}
                            sm={null}
                            md={null}
                            lg={null}
                            label='Comments'
                            value={value.coments}
                            onChange={event => setValue(prev => ({ ...prev, coments: event.target.value }))}
                        />
                        <Button onClick={value.id ? update : create} variant='contained' sx={{ m: 2 }}>
                            Save
                        </Button>
                    </Grid>
                    <Grid container item spacing={1} justifyContent="flex-start">
                        <TextField
                            sm={9}
                            md={9}
                            lg={9}
                            label='Reminder Text'
                            value={value.reminderText}
                            onChange={event => setValue(prev => ({ ...prev, reminderText: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <DateTimePicker
                            sm={3}
                            md={3}
                            lg={3}
                            label='Reminder Date'
                            boldLabel={<Typography fontSize="0.8vw" fontWeight='bold'>Reminder</Typography>}
                            value={value.reminderDate}
                            format="dd/MM/yyyy"
                            isShowTime={false}
                            onChange={(date) => {
                                const pad = (n) => `${Math.floor(Math.abs(n))}`.padStart(2, '0');
                                const getTimezoneOffset = (date) => {
                                    const tzOffset = -date.getTimezoneOffset(); // getTimezoneOffset returns a negative value for positive offsets
                                    const diff = tzOffset >= 0 ? '+' : '-';
                                    return diff + pad(tzOffset / 60) + ':' + pad(tzOffset % 60);
                                };
                                const formatLocalISO = (date) => {
                                    let isoDate = date.getFullYear() + '-' + pad(date.getMonth() + 1) + '-' + pad(date.getDate());
                                    isoDate += 'T' + pad(date.getHours()) + ':' + pad(date.getMinutes()) + ':' + pad(date.getSeconds());
                                    return isoDate + getTimezoneOffset(date);
                                };
                                setValue(prev => ({ ...prev, reminderDate: formatLocalISO(date) }))
                            }}
                        />
                    </Grid>
                    <Grid container item spacing={1}>
                        <Grid item xs={12}>
                            <Typography variant='subtitle1'>Add Contact</Typography>
                        </Grid>
                        <TextField
                            lg={null}
                            label='Email'
                            value={value.email}
                            onChange={event => setValue(prev => ({ ...prev, email: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Position'
                            value={value.position}
                            onChange={event => setValue(prev => ({ ...prev, position: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Mobile'
                            value={value.mobile}
                            onChange={event => setValue(prev => ({ ...prev, mobile: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='English Name'
                            value={value.name}
                            onChange={event => setValue(prev => ({ ...prev, name: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Business Phone'
                            value={value.businessPhone}
                            onChange={event => setValue(prev => ({ ...prev, businessPhone: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Fax'
                            value={value.faxContent}
                            onChange={event => setValue(prev => ({ ...prev, faxContent: event.target.value }))}
                            readOnly={readOnly}
                        />

                        <Grid item xs={12}>
                            <Typography variant='subtitle1'>Contact 2</Typography>
                        </Grid>
                        <TextField
                            lg={null}
                            label='Email'
                            value={value.email2}
                            onChange={event => setValue(prev => ({ ...prev, email2: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Position'
                            value={value.position2}
                            onChange={event => setValue(prev => ({ ...prev, position2: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Mobile'
                            value={value.mobile2}
                            onChange={event => setValue(prev => ({ ...prev, mobile2: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='English Name'
                            value={value.name2}
                            onChange={event => setValue(prev => ({ ...prev, name2: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Business Phone'
                            value={value.businessPhone2}
                            onChange={event => setValue(prev => ({ ...prev, businessPhone2: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Fax'
                            value={value.faxContent2}
                            onChange={event => setValue(prev => ({ ...prev, faxContent2: event.target.value }))}
                            readOnly={readOnly}
                        />

                        <Grid item xs={12}>
                            <Typography variant='subtitle1'>Contact 3</Typography>
                        </Grid>
                        <TextField
                            lg={null}
                            label='Email'
                            value={value.email3}
                            onChange={event => setValue(prev => ({ ...prev, email3: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Position'
                            value={value.position3}
                            onChange={event => setValue(prev => ({ ...prev, position3: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Mobile'
                            value={value.mobile3}
                            onChange={event => setValue(prev => ({ ...prev, mobile3: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='English Name'
                            value={value.name3}
                            onChange={event => setValue(prev => ({ ...prev, name3: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Business Phone'
                            value={value.businessPhone3}
                            onChange={event => setValue(prev => ({ ...prev, businessPhone3: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Fax'
                            value={value.faxContent3}
                            onChange={event => setValue(prev => ({ ...prev, faxContent3: event.target.value }))}
                            readOnly={readOnly}
                        />

                        <Grid item xs={12}>
                            <Typography variant='subtitle1'>Contact 4</Typography>
                        </Grid>
                        <TextField
                            lg={null}
                            label='Email'
                            value={value.email4}
                            onChange={event => setValue(prev => ({ ...prev, email4: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Position'
                            value={value.position4}
                            onChange={event => setValue(prev => ({ ...prev, position4: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Mobile'
                            value={value.mobile4}
                            onChange={event => setValue(prev => ({ ...prev, mobile4: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='English Name'
                            value={value.name4}
                            onChange={event => setValue(prev => ({ ...prev, name4: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Business Phone'
                            value={value.businessPhone4}
                            onChange={event => setValue(prev => ({ ...prev, businessPhone4: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Fax'
                            value={value.faxContent4}
                            onChange={event => setValue(prev => ({ ...prev, faxContent4: event.target.value }))}
                            readOnly={readOnly}
                        />

                        <Grid item xs={12}>
                            <Typography variant='subtitle1'>Contact 5</Typography>
                        </Grid>
                        <TextField
                            lg={null}
                            label='Email'
                            value={value.email5}
                            onChange={event => setValue(prev => ({ ...prev, email5: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Position'
                            value={value.position5}
                            onChange={event => setValue(prev => ({ ...prev, position5: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Mobile'
                            value={value.mobile5}
                            onChange={event => setValue(prev => ({ ...prev, mobile5: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='English Name'
                            value={value.name5}
                            onChange={event => setValue(prev => ({ ...prev, name5: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Business Phone'
                            value={value.businessPhone5}
                            onChange={event => setValue(prev => ({ ...prev, businessPhone5: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <TextField
                            lg={null}
                            label='Fax'
                            value={value.faxContent5}
                            onChange={event => setValue(prev => ({ ...prev, faxContent5: event.target.value }))}
                            readOnly={readOnly}
                        />
                        <view style={{ marginLeft: 10 }}>
                            <FormControlLabel
                                control={
                                    <Checkbox checked={(value.active != null) ? value.active : true} onChange={event => setValue(prev => ({ ...prev, active: event.target.checked }))} disabled={readOnly} />
                                }
                                label='Active/In-Active'
                            />
                        </view>
                    </Grid>
                    <Grid item container>
                        <TextField
                            lg={4}
                            label='Notification Mail'
                            value={value.notificationMail}
                            onChange={event => setValue(prev => ({ ...prev, notificationMail: event.target.value }))}
                        />
                    </Grid>
                    <Grid item container>
                        <p>Shipper</p>
                    </Grid>
                    <Grid item container>
                        <Grid item container style={{ maxWidth: "300px" }} flexDirection="column">
                            <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px", borderBottom: "1px solid grey" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={emailNotificationShipperAll} onChange={event => emailNotificationShipperAll ? setEmailNotificationShipperAll(false) : setEmailNotificationShipperAll(true)} />
                                    }
                                    label={"All Shipper"}
                                />
                            </view>
                            <view style={{ marginTop: "10px", marginLeft: "0", maxWidth: "500px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={emailNotificationShipper1} onChange={event => emailNotificationShipper1 ? setEmailNotificationShipper1(false) : setEmailNotificationShipper1(true)} />
                                    }
                                    label={"In Process"}
                                />
                            </view>
                            <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={emailNotificationShipper2} onChange={event => emailNotificationShipper2 ? setEmailNotificationShipper2(false) : setEmailNotificationShipper2(true)} />
                                    }
                                    label={"No Reply"}
                                />
                            </view>
                            <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={emailNotificationShipper3} onChange={event => emailNotificationShipper3 ? setEmailNotificationShipper3(false) : setEmailNotificationShipper3(true)} />
                                    }
                                    label={"Not Ready"}
                                />
                            </view>
                            <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={emailNotificationShipper4} onChange={event => emailNotificationShipper4 ? setEmailNotificationShipper4(false) : setEmailNotificationShipper4(true)} />
                                    }
                                    label={"Waiting for payment"}
                                />
                            </view>
                            <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={emailNotificationShipper5} onChange={event => emailNotificationShipper5 ? setEmailNotificationShipper5(false) : setEmailNotificationShipper5(true)} />
                                    }
                                    label={"Expected Ready"}
                                />
                            </view>
                            <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={emailNotificationShipper6} onChange={event => emailNotificationShipper6 ? setEmailNotificationShipper6(false) : setEmailNotificationShipper6(true)} />
                                    }
                                    label={"Ready no trucks"}
                                />
                            </view>
                            <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={emailNotificationShipper7} onChange={event => emailNotificationShipper7 ? setEmailNotificationShipper7(false) : setEmailNotificationShipper7(true)} />
                                    }
                                    label={"Ready no vessel/flight"}
                                />
                            </view>
                            <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={emailNotificationShipper8} onChange={event => emailNotificationShipper8 ? setEmailNotificationShipper8(false) : setEmailNotificationShipper8(true)} />
                                    }
                                    label={"Ready for pick-up"}
                                />
                            </view>
                        </Grid>
                    </Grid>
                    <Grid item container>
                        <p>Trucking</p>
                    </Grid>
                    <Grid item container>
                        <Grid item container style={{ maxWidth: "300px"}} flexDirection="column">
                            <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px", borderBottom: "1px solid grey" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={emailNotificationTruckingAll} onChange={event => emailNotificationTruckingAll ? setEmailNotificationTruckingAll(false) : setEmailNotificationTruckingAll(true)} />
                                    }
                                    label={"All Trucking"}
                                />
                            </view>
                            <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={emailNotificationTrucking1} onChange={event => emailNotificationTrucking1 ? setEmailNotificationTrucking1(false) : setEmailNotificationTrucking1(true)} />
                                    }
                                    label={"Booked"}
                                />
                            </view>
                            <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={emailNotificationTrucking2} onChange={event => emailNotificationTrucking2 ? setEmailNotificationTrucking2(false) : setEmailNotificationTrucking2(true)} />
                                    }
                                    label={"Collected"}
                                />
                            </view>
                        </Grid>
                    </Grid>
                    <Grid item container>
                        <p>Departure</p>
                    </Grid>
                    <Grid item container>
                        <Grid item container style={{ maxWidth: "300px" }} flexDirection="column">
                            <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px", borderBottom: "1px solid grey" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={emailNotificationDEPAll} onChange={event => emailNotificationDEPAll ? setEmailNotificationDEPAll(false) : setEmailNotificationDEPAll(true)} />
                                    }
                                    label={"All Departure"}
                                />
                            </view>
                            <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={emailNotificationDEP1} onChange={event => emailNotificationDEP1 ? setEmailNotificationDEP1(false) : setEmailNotificationDEP1(true)} />
                                    }
                                    label={"Expected arrival"}
                                />
                            </view>
                            <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={emailNotificationDEP2} onChange={event => emailNotificationDEP2 ? setEmailNotificationDEP2(false) : setEmailNotificationDEP2(true)} />
                                    }
                                    label={"Arrived"}
                                />
                            </view>
                            <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={emailNotificationDEP3} onChange={event => emailNotificationDEP3 ? setEmailNotificationDEP3(false) : setEmailNotificationDEP3(true)} />
                                    }
                                    label={"Expected Departure"}
                                />
                            </view>
                            <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={emailNotificationDEP4} onChange={event => emailNotificationDEP4 ? setEmailNotificationDEP4(false) : setEmailNotificationDEP4(true)} />
                                    }
                                    label={"Sailed / Took off"}
                                />
                            </view>
                        </Grid>
                    </Grid>

                    <Grid item container>
                        <p>Customs</p>
                    </Grid>
                    <Grid item container>
                        <Grid item container style={{ maxWidth: "300px" }} flexDirection="column">
                            <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={emailNotificationCustoms1} onChange={event => emailNotificationCustoms1 ? setEmailNotificationCustoms1(false) : setEmailNotificationCustoms1(true)} />
                                    }
                                    label={"Released"}
                                />
                            </view>
                        </Grid>
                    </Grid>
                    <Grid item container>
                        <p>Delivered</p>
                    </Grid>
                    <Grid item container>
                        <Grid item container style={{ maxWidth: "300px" }} flexDirection="column">
                            <view style={{ marginTop: "0px", marginLeft: "0", maxWidth: "500px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={emailNotificationDelivered1} onChange={event => emailNotificationDelivered1 ? setEmailNotificationDelivered1(false) : setEmailNotificationDelivered1(true)} />
                                    }
                                    label={"Delivered"}
                                />
                            </view>
                        </Grid>
                    </Grid>
                    {!readOnly ?
                        <Grid container item justifyContent='flex-end'>
                            <Button onClick={value.id ? update : create} variant='contained' sx={{ mr: 2 }}>
                                Save
                            </Button>
                            <Button variant='contained' color='secondary' onClick={props.onHandleCancel}>
                                Cancel
                            </Button>
                        </Grid>
                        : ''}
                </Grid>
            )}
            {openOrderModal && (
                <DialogWithGoBackWrapper
                    maxWidth='md'
                    open={openOrderModal}
                    title={'New pickup address'}
                    onHandleCancel={onHandleCancelModal}>
                    <AddServiceProvider type={5} onHandleCancel={onHandleCancelModal} id={null} readOnly={false} loginUser={props.loginUser} />
                </DialogWithGoBackWrapper>
            )}
        </div>
    );
};

export default AddServiceProvider;
